import { useEffect } from 'react';

import { clientIsOnline } from '@/services/actions';
import { useClientStatusStore } from '@stores/useClientStatusStore';
import { handleError } from './utils/errors';

const ClientStatusFetcher = () => {
  const { updateStatus } = useClientStatusStore();

  useEffect(() => {
    const setStatus = async () => {
      try {
        const isOnline = await clientIsOnline();
        updateStatus(isOnline);
      } catch (error) {
        handleError(error);
        updateStatus(false);
      }
    };

    const id = setInterval(setStatus, 15000);
    setTimeout(setStatus, 50);

    return () => {
      clearInterval(id);
    };
  }, [updateStatus]);

  return null;
};

export default ClientStatusFetcher;
